import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';


const goBack = () => {
  window.history.back()
}

interface BackProps {
  title?: string
}

const BackButtonComponent = (props: BackProps) => {
  return (
    <>
      <Stack direction="row" spacing={1}>
        <Button id="6679d72e-577f-4f20-b8b2-cc19f7a93702" aria-label="delete" onClick={goBack} startIcon={<ArrowBackIosNewIcon />}>
           {props.title ? props.title : 'Back'}
      </Button>
      </Stack>
    </>
  );
};

export default BackButtonComponent;
